// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10356); hand-edits allowed (see docs/architecture.md)

/** `this.PAPA_OBJECTS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_PAPA_OBJECTS(): any {
  return [
    [4, "obj_pulse_mod", "obj_rad_cont", "obj_coil", "obj_orange_book"],
    [4, "obj_big_cell", "obj_rad_lock", "obj_rad_cont", "obj_violet_book"],
    [3, "obj_coil", "obj_radio", "obj_red_book"],
    [4, "obj_pulse_mod", "obj_eg_generator", "obj_rad_cont", "obj_green_book"],
    [4, "obj_rad_lock", "obj_coil", "obj_skyblue_book", "obj_black_book"],
    [4, "obj_ultra_mod", "obj_rad_cont", "obj_radio", "obj_blue_book"],
    [3, "obj_rad_lock", "obj_eg_generator", "obj_yellow_book"],
    [3, "obj_big_cell", "obj_rad_cont", "obj_white_book"]
  ];
}
